export enum ToasterPositionEnum {
    TOP_CENTER = 'top-center',
    BOTTOM_RIGHT = 'bottom-right',
}
